<template>
  <div class="about">
    <h1>New Process</h1>
    <b-form @submit.prevent="on_submit" @reset="on_reset">
      <KnowledgeProcessForm :form="form"></KnowledgeProcessForm>
      <b-button type="submit" variant="primary">Add process</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';
import KnowledgeProcessForm from '@/components/KnowledgeProcessForm.vue'

export default {
  data () {
    return {
      form: {
        name: '',
        description: ''
      },
      show: true
    }
  },
  methods: {
    on_submit (evt) {
      evt.preventDefault();
      this.$http.post('v1/kb/1/processes', this.form).then(response => {
          console.log(response)
          if (response.status == 200) {
              this.$router.push('/kb/1/process/' + response.data.response.knowledge_process_id + '/detail');
          }
      })
    },
    on_reset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.name = '';
      this.form.description = '';
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true });
    }
  },
  components: {
    KnowledgeProcessForm
  }
}
</script>
